import React from "react";
import Partner from "./Partner";

export type CoupleProps = {
  className?: string;
};
const Couple: React.FC<CoupleProps> = (props) => {
  return (
    <div
      className={`bg-white shadow-md flex flex-col items-start rounded-lg ${
        props.className ?? ""
      }`}
    >
      <Partner className="bg-or_gray-100 border-green-500 rounded-t-lg">Husband</Partner>
      <Partner className="rounded-b-lg border-red-500">Wife</Partner>
    </div>
  );
};

export default Couple;
